import { createContext, useContext, useState } from 'react';
import type { PropsWithChildren } from 'react';

import { config } from '~app/config';

import { ampli } from '~entities/ampli';

import type { AuthApi } from '@breezeventures/web-ph-client-auth/api';

import { GatewayAuthApi } from './gateway-auth-api';

const AuthApiContext = createContext<AuthApi | null>(null);

export const AuthApiProvider = ({ children }: PropsWithChildren) => {
  const [authApi] = useState(
    () =>
      new GatewayAuthApi(config.authClientId, config.apiHost, (event) => {
        ampli.client.track(event);
      })
  );

  return (
    <AuthApiContext.Provider value={authApi}>
      {children}
    </AuthApiContext.Provider>
  );
};

export const useAuthApi = (): AuthApi => {
  const api = useContext(AuthApiContext);

  if (!api) {
    throw new Error('useAuthApi must be used within AuthApiProvider');
  }

  return api;
};
